import { type SurveyDynamicModel } from '../types/survey-dynamic-model.type'

export const urlFromSurvey = (
  survey: SurveyDynamicModel,
): string | undefined => {
  if (!survey.token) {
    return undefined
  }
  return `${window.location.origin}/?token=${survey.token}`
}
